import { uniqueArray } from 'src/utils';
import {
  FormattedNamedOffender,
  SubmissionType,
} from './formattedNamedOffender.type';

const getUniqueReportsOrEvents = (
  ids: {
    id: string;
    type: SubmissionType;
  }[],
) => {
  const uniqueIds = uniqueArray(ids.map((r) => r.id));
  const uniqueReports = uniqueIds.map((id) => {
    const existingReports = ids.filter((r) => r.id === id);
    return {
      id,
      type: existingReports.map((r) => r.type).includes('Presubmission')
        ? ('Presubmission' as SubmissionType)
        : ('Postsubmission' as SubmissionType),
    };
  });

  return uniqueReports;
};

const normalizeExternalName = (name: string | null | undefined) =>
  name ? name.trim().toLowerCase() : '';

const getOffenderKey = (offender: FormattedNamedOffender) => {
  if (offender.external) {
    const normalizedName = normalizeExternalName(offender.name);
    return normalizedName
      ? `external:${normalizedName}`
      : `external-id:${offender.id}`;
  }

  return `internal:${offender.id}`;
};

export const removeDuplicateNamedOffenders = (
  offenders: FormattedNamedOffender[],
) => {
  const uniqueOffenders = new Map<string, FormattedNamedOffender>();

  offenders.forEach((offender) => {
    const offenderKey = getOffenderKey(offender);
    const existingEntry = uniqueOffenders.get(offenderKey);
    if (existingEntry) {
      existingEntry.reports = getUniqueReportsOrEvents([
        ...existingEntry.reports,
        ...offender.reports,
      ]);
      existingEntry.events = getUniqueReportsOrEvents([
        ...existingEntry.events,
        ...offender.events,
      ]);
    } else {
      uniqueOffenders.set(offenderKey, { ...offender });
    }
  });

  return Array.from(uniqueOffenders.values());
};
